import React from 'react';
import './AccessOfferTitle.scss';

export default function AccessOfferTitle({content}) {
    return (
        <div className='crisis-access_offer_title'>
            <h2>{content}</h2>
        </div>
    )
}